
import { defineComponent, h, PropType } from 'vue';
import { TransformedImage } from '@/types';

// const basicSvg = (
//   width: number,
//   height: number,
//   bg: string
// ) => `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}">
//   <rect fill="${bg}" width="${width}" height="${height}"/>
// </svg>`;

export default defineComponent({
  props: {
    image: {
      type: Object as PropType<TransformedImage>,
      required: true,
    },
    backgroundClass: {
      type: String,
      // default: 'bg-gray-100',
      default: '',
    },
  },
  setup(props) {
    return () => {
      const paddingTop = `${(props.image.height / props.image.width) * 100}%`;
      const img = h('img', {
        class: 'w-full absolute top-0',
        src: props.image.src,
      });
      const inner = h(
        'div',
        {
          class: ['relative', props.backgroundClass],
          style: { paddingTop },
        },
        img
      );
      return h('div', inner);
    };
  },
});
